import React, { useState, useRef, useEffect, useCallback } from "react";
import { TextField, Button } from "@ann/web-components";
import { useMyMemberContext } from "../../../../context";
import {
  FiltersContainer,
  FiltersLeftContent,
  FiltersRightContent,
} from "./Filters.styled";

const Filters = ({
  loading = false,
  filters,
  filterHandlers,
  filterUI,
  onAddSuggestion,
}) => {
  const { myRole } = useMyMemberContext();
  const [searchValue, setSearchValue] = useState(filters?.searchValue || "");
  const searchTimeoutRef = useRef(null);

  const { handleSearchChange, handleClearAllFiltersWithKeys } = filterHandlers;

  // Determinar permisos según el rol
  const canAddSuggestion = myRole === 'ADMIN' || myRole === 'CONTRIBUTOR';

  const handleSearchChangeCallback = useCallback((value) => {
    setSearchValue(value);
    
    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Set new timeout for 500ms debounce
    searchTimeoutRef.current = setTimeout(() => {
      if (handleSearchChange) {
        handleSearchChange(value);
      }
    }, 500);
  }, [handleSearchChange]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // Sync local state with filters when it changes
  useEffect(() => {
    setSearchValue(filters?.searchValue || "");
  }, [filters?.searchValue]);

  return (
    <FiltersContainer>
      <FiltersLeftContent>
        <TextField
          iconLeft="search"
          onChange={handleSearchChangeCallback}
          size="small"
          placeholder="Search"
          value={searchValue}
          disabled={loading}
        />
      </FiltersLeftContent>
      <FiltersRightContent>
        <Button
          iconRight="plus"
          label="Add suggestion"
          size="medium"
          onClick={onAddSuggestion}
          disabled={loading} // TODO: Agregar && !canAddSuggestion cuando myMember está funcionando
        />
      </FiltersRightContent>
    </FiltersContainer>
  );
};

export default Filters;
